import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';
import List from '../PageBuilder/List';
import ImagePicker from '../PageBuilder/pickers/ImagePicker/ImagePicker';
import SelectMenu from '../PageBuilder/forms/SelectMenu';
import TextInput from '../PageBuilder/forms/TextInput';
import TextArea from '../PageBuilder/forms/TextArea';

const articleClass = (variant) => {
  switch (variant) {
    case '2_columns':
      return 'flex-grid-halfs';
    case '3_columns':
      return 'flex-grid-thirds';
    case '4_columns':
      return 'flex-grid-quarters';
    default:
      return 'flex-grid-halfs';
  }
};

const articleImageVariant = (variant) => {
  switch (variant) {
    case '2_columns':
      return 'article_feed_1';
    case '3_columns':
      return 'article_feed_2';
    case '4_columns':
      return 'article_feed_3';
    default:
      return 'article_feed_1';
  }
};

const ArticleFeedWidget = ({ list, variant, containerSettings }) => (
  <Container settings={containerSettings}>
    <div className={`article-feed ${articleClass(variant)}`}>
      {list.map((item, idx) =>
        <div className="col" key={idx}>
          <article className="card">
            <div className="thumb-image-wrapper">
              <a href={item.link}>
                <Img src={item.image} variant={articleImageVariant(variant)} />
              </a>
            </div>

            <div className="text">
              <h6 className="sup-title">{item.meta}</h6>

              <h4 className="title"><a href={item.link}>{item.title}</a></h4>

              <p>{item.description}</p>
            </div>
          </article>
        </div>)}
    </div>
  </Container>
);

ArticleFeedWidget.title = 'Article Feed';
ArticleFeedWidget.preview = 'article-feed.png';
ArticleFeedWidget.category = 'Lists';

ArticleFeedWidget.propTypes = {
  list: PropTypes.array.isRequired,
  variant: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

ArticleFeedWidget.defaults = {
  list: [
    { id: 1, image: 'http://placehold.it/568x338', link: '#', meta: 'Summary, or meta info', title: 'Title of article', description: 'Трябва да разбереш, нашето общество е толкова огромно, че не можем да позволим на когото и да било да дразни и вълнува отделните групи, които го съставляват. Запитай се сам какво преди всичко желаем ние в нашата страна.' },
    { id: 2, image: 'http://placehold.it/568x338', link: '#', meta: 'Summary, or meta info', title: 'Title of article', description: 'Трябва да разбереш, нашето общество е толкова огромно, че не можем да позволим на когото и да било да дразни и вълнува отделните групи, които го съставляват. Запитай се сам какво преди всичко желаем ние в нашата страна.' },
  ],
  variant: '2_columns',
  containerSettings: {},
};

const ThumbField = ({ settings, onChangeItem }) => (
  <div>
    <ImagePicker
      onChange={value => onChangeItem('image', value)}
      value={settings.image}
    />

    <TextInput
      label="Link"
      onChange={value => onChangeItem('link', value)}
      value={settings.link}
    />

    <TextInput
      label="Meta"
      onChange={value => onChangeItem('meta', value)}
      value={settings.meta}
    />

    <TextInput
      label="Title"
      onChange={value => onChangeItem('title', value)}
      value={settings.title}
    />

    <TextArea
      label="Short Description"
      onChange={value => onChangeItem('description', value)}
      value={settings.description}
    />
  </div>
);

ThumbField.propTypes = {
  settings: PropTypes.object.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

ArticleFeedWidget.adminFields = (items, onChange, settings) => (
  <div>
    <SelectMenu
      label="Variant"
      options={[['2_columns', '2 Columns'], ['3_columns', '3 Columns'], ['4_columns', '4 Columns']]}
      value={settings.variant}
      onChange={value => onChange('variant', value)}
    />

    <List
      listItem={(settings, onChangeItem) =>
        <ThumbField settings={settings} onChangeItem={onChangeItem} />}
      onChangeList={onChange}
      items={items}
    />
  </div>
);
export default ArticleFeedWidget;
